<template>
  <div
    :class="`boarding-pass-link boarding-pass-link--${index > 0 ? 'with' : 'without'}-divider`"
  >
    <component
      :is="pdf_url ? 'a' : 'div'"
      :href="pdf_url || false"
      class="boarding-pass-link__label"
    >
      {{ boarding_passes.traveler_label }}
      <vb-icon name="chevron_right" :size="8" color="--info" />
    </component>
    <div v-if="badges.length" class="boarding-pass-link__badges">
      <a
        v-for="badge in badges"
        :key="badge.format"
        :href="badge.url"
        target="_blank"
      >
        <img
          :src="badge.src"
          :alt="badge.alt"
          :class="`boarding-pass-link__badge boarding-pass-link__badge--${badge.format}`"
          @error="failed.push(badge.format)"
        />
      </a>
    </div>
  </div>
</template>

<script>
  // Official vendor artwork only: Google and Apple both forbid recreating or
  // translating their badge.
  const BADGES = {
    google_wallet: {
      src: '/assets/images/common/wallet/add-to-google-wallet.svg',
      alt: 'Aggiungi a Google Wallet',
    },
    passkit: {
      src: '/assets/images/common/wallet/add-to-apple-wallet.svg',
      alt: 'Aggiungi ad Apple Wallet',
    },
  };

  const pass_url = ({ public_url, download_url }) => public_url || download_url;

  export default {
    name: 'boarding-pass-link',
    props: {
      // One traveler on one leg: { traveler_label, formats: [...] }. At least
      // one format carries a url — the caller filters the others out.
      boarding_passes: { type: Object, required: true },
      index: { type: Number, default: 0 },
    },
    data() {
      return { failed: [] };
    },
    computed: {
      // Whatever is not a wallet pass is the document behind the name.
      pdf_url() {
        const pdf = this.boarding_passes.formats.find(
          (pass) => !BADGES[pass.format]
        );
        return (pdf && pass_url(pdf)) || '';
      },
      // A missing badge file drops the badge instead of showing it broken.
      badges() {
        return this.boarding_passes.formats
          .filter(
            (pass) => BADGES[pass.format] && !this.failed.includes(pass.format)
          )
          .map((pass) => ({
            ...BADGES[pass.format],
            format: pass.format,
            url: pass_url(pass),
          }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .boarding-pass-link {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;

    &--with-divider {
      border-left: 1px solid $gray-200;
      padding-left: $grid-gutter-width;
    }

    &__label {
      display: flex;
      align-items: center;
      gap: 3px;
    }

    // Underlined only when the pdf makes it clickable.
    a.boarding-pass-link__label {
      text-decoration: underline;
    }

    &__badges {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      // Google requires 8px of clear space around its button.
      gap: 8px;
    }

    // Sizes come from the vendors' brand guidelines: Google requires a 48px
    // minimum height, Apple a tenth of the badge height as clear space. Do not
    // restyle beyond this.
    &__badge {
      display: block;
      height: 48px;
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
</style>
